<div
  class="shared-input-search-container"
  id="shared-input-search-container"
  [ngClass]="{ invalid: isInputInvalid() }"
>
  <form
    [formGroup]="inputSearchForm"
    id="shared-input-search-form"
    class="input-field-form"
    [ngClass]="{ 'default-input-field-color': defaultInputFieldColor }"
  >
    <app-input-field
      class="input-field"
      id="shared-input-search-input-field"
      [hasCustomError]="!!errorMessage"
      [customErrorMsg]="errorMessage"
      [customErrorMsgTextType]="customErrorMsgTextType"
      [placeholder]="placeholderKey | translate"
      [tooltipIcon]="false"
      [maxLength]="maxInputLength"
      [showToolTipText]="false"
      [isRequired]="false"
      [inputLabel]="inputLabelKey | translate"
      [isDisabled]="disableInputField"
      [control]="getInputSearchFormControl()"
      (changeInputValue)="onInputChange($event)"
      (closeIconClick)="closeIconClickHandler()"
      (enterPress)="onEnterPress()"
    ></app-input-field>
  </form>

  <app-button
    *ngIf="!isSpinnerVisible; else showSpinner"
    id="shared-input-search-button"
    class="input-search-button"
    height="3.6em"
    [text]="buttonTextKey | translate"
    [buttonType]="buttonType"
    [isDisabled]="isButtonDisabled"
    (buttonClick)="onButtonClick()"
  ></app-button>

  <ng-template #showSpinner>
    <div id="shared-input-search-button-spinner-container" class="spinner-container">
      <app-spinner
        id="shared-input-search-button-spinner"
        [diameter]="'medium'"
      ></app-spinner></div
  ></ng-template>
</div>
